import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CarCard from '../components/CarCard';
import MobileParking from '../components/MobileParking';
import WavyBackground from '../components/WavyBackground';
import apiService from '../services/api';
import '../styles/Home.css';

const Home = () => {
  const [featuredCars, setFeaturedCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Fond global géré au niveau de l'application (App.js)

  useEffect(() => {
    loadFeaturedCars();
  }, []);

  const loadFeaturedCars = async () => {
    try {
      setLoading(true);
      setError(null);

      // Récupérer les véhicules marqués en vedette
      const response = await apiService.getCarsFeatured();

      if (response.success) {
        setFeaturedCars(response.data);
      } else {
        setError('Erreur lors du chargement des véhicules');
      }
    } catch (error) {
      console.error('Erreur lors du chargement:', error);
      setError('Erreur lors du chargement des véhicules');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home">
      {/* Section Hero */}
      <section className="hero">
        <WavyBackground
          backgroundFill="#1a1a1a"
          colors={["#8f8e85", "#a8a26c", "#ccbe45"]}
          waveWidth={30}
          blur={0.9}
          speed="medium"
          waveOpacity={0.15}
          containerClassName="hero-wavy"
        />
        <div className="hero-content">
          <div className="hero-image-bubble desktop-only">
            <a
              href="https://www.google.fr/maps/place/72+Av.+Gustave+Eiffel,+37390+Notre-Dame-d'O%C3%A9/@47.4388149,0.6961438,16z/data=!3m1!4b1!4m6!3m5!1s0x47fcd4d7a65478b3:0x48faf86176f4595b!8m2!3d47.4388113!4d0.6987187!16s%2Fg%2F11c4cgmptj?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/img/parc1.webp" alt="Notre parc automobile 1" />
            </a>
          </div>
          <div className="hero-main">
            <div className="hero-logo">
              <img src="/img/logoFdp.webp" alt="FDP AUTOMOBILES" className="hero-logo-image" />
            </div>
            <h1 className="hero-title">Bienvenue</h1>
            <h2 className="hero-subtitle">Centre Automobile Multimarques</h2>
            <h3 className="hero-brand">FDP AUTOMOBILES</h3>
            <p className="hero-description">
              Votre partenaire de confiance depuis plus de 45 ans
            </p>
            <div className="hero-buttons">
              <Link to="/stock" className="btn btn-primary">
                Notre Stock
              </Link>
              <a href="tel:0247540186" className="btn btn-secondary">
                Nous Contacter
              </a>
            </div>
          </div>
          <div className="hero-image-bubble desktop-only">
            <a
              href="https://www.google.fr/maps/place/72+Av.+Gustave+Eiffel,+37390+Notre-Dame-d'O%C3%A9/@47.4388149,0.6961438,16z/data=!3m1!4b1!4m6!3m5!1s0x47fcd4d7a65478b3:0x48faf86176f4595b!8m2!3d47.4388113!4d0.6987187!16s%2Fg%2F11c4cgmptj?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/img/parc2.webp" alt="Notre parc automobile 2" />
            </a>
          </div>
          <MobileParking />
        </div>
      </section>
      {/* Section Véhicules en vedette */}
      {featuredCars.length > 0 && (
        <section className="featured-cars">
          <div className="container">
            <h2 className="section-title">Véhicules en vedette</h2>
            {loading ? (
              <div className="loading-message">
                <p>Chargement des véhicules en vedette...</p>
              </div>
            ) : error ? (
              <div className="error-message">
                <p>{error}</p>
              </div>
            ) : (
              <>
                <div className="cars-grid">
                  {featuredCars.map(car => (
                    <CarCard key={car.id} car={car} featured={true} />
                  ))}
                </div>
                <div className="text-center">
                  <Link to="/stock" className="btn btn-outline">
                    Notre Stock
                  </Link>
                </div>
              </>
            )}
          </div>
        </section>
      )}

      {/* Section Nos Avantages */}
      <section className="advantages">
        <div className="container">
          <h2 className="section-title">Nos Avantages</h2>
          <div className="advantages-grid">
            <div className="advantage-card">
              <div className="advantage-icon">
                <img src="/img/LaVoiture.png" alt="Voiture" />
              </div>
              <h3>Exposition permanente avec 80 véhicules</h3>
              <p>Un large choix de véhicules d'occasion soigneusement sélectionnés pour leur qualité et leur fiabilité</p>
            </div>
            <div className="advantage-card">
              <div className="advantage-icon">🏅​</div>
              <h3>Garantie mécanique et service carte grise</h3>
              <p>Tous nos véhicules sont garantis avec un service complet d'immatriculation et de carte grise</p>
            </div>
            <div className="advantage-card">
              <div className="advantage-icon">⚡</div>
              <h3>Réactivité et proximité</h3>
              <p>Une équipe à votre écoute pour vous accompagner dans votre achat avec rapidité et professionnalisme</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section À Propos */}
      <section className="about">
        <div className="container">
          <h2 className="section-title">
            À Propos de <br/>
            FDP AUTOMOBILES
          </h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                <strong>FDP AUTOMOBILES</strong> est votre partenaire de confiance depuis plus de 45 ans.
                Spécialisés dans la vente de véhicules d'occasion, nous mettons notre expertise au service de nos clients
                pour leur offrir les meilleures opportunités du marché automobile.
              </p>
              <p>
                Situés au <strong>72 Avenue Gustave Eiffel à Notre Dame D'Oé</strong>, nous disposons d'une exposition permanente
                avec plus de 80 véhicules soigneusement sélectionnés. Notre équipe expérimentée vous accompagne dans votre choix
                et vous garantit un service complet incluant la garantie mécanique et les démarches administratives.
              </p>
              <div className="about-features desktop-only">
                <div className="feature">
                  <span className="feature-icon">🏆</span>
                  <span>45 ans d'expérience</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">
                    <img src="/img/LaVoiture.png" alt="Voiture" />
                  </span>
                  <span>80+ véhicules en stock</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">🏅​</span>
                  <span>Service complet</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">📍</span>
                  <span>Notre Dame D'Oé</span>
                </div>
              </div>
              <div className="about-features-mobile">
                <a href="https://www.google.fr/maps/place/72+Av.+Gustave+Eiffel,+37390+Notre-Dame-d'O%C3%A9" target="_blank" rel="noopener noreferrer" className="feature">
                  <span className="feature-icon">📍</span>
                  <div className="feature-text">
                    <span>72 Avenue Gustave Eiffel</span>
                    <span className="feature-subtext">37390 Notre Dame D'Oé</span>
                  </div>
                </a>
                <a href="tel:0247540186" className="feature">
                  <span className="feature-icon">📞</span>
                  <div className="feature-text">
                    <span>02 47 54 01 86</span>
                  </div>
                </a>
                <a href="mailto:fdp-automobiles@live.fr" className="feature">
                  <span className="feature-icon">✉️</span>
                  <div className="feature-text">
                    <span>fdp-automobiles@live.fr</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="about-contact">
              <h3>Contactez-nous</h3>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="contact-icon">📍</span>
                  <div>
                    <p>72 Avenue Gustave Eiffel</p>
                    <p>37390 Notre Dame D'Oé</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📞</span>
                  <div>
                    <p>02 47 54 01 86</p>
                    <p>Lun-Ven: 10h-12h • 14h-18h30</p>
                  </div>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">✉️</span>
                  <div>
                    <p>fdp-automobiles@live.fr</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Certifications */}
      <section className="certification">
        <div className="container">
          <h2 className="section-title">Nos Certifications</h2>
          <div className="certification-grid">
            <div className="certification-card">
              <div className="certification-icon">🇫🇷</div>
              <h3>Immatriculation Française</h3>
              <p>Tous nos véhicules sont immatriculés en France avec carte grise française</p>
            </div>
            <div className="certification-card">
              <div className="certification-icon">🛡️</div>
              <h3>Garantie Nationale</h3>
              <p>Garantie constructeur valable sur tout le territoire français</p>
            </div>
            <div className="certification-card">
              <div className="certification-icon">📋</div>
              <h3>Contrôle Technique</h3>
              <p>Contrôle technique à jour pour tous nos véhicules</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Home; 